<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;min-width:1020px !important">
      <el-form :inline="true" xlabel-width="50px">        
        <el-col style='margin:0px'>
        <el-form-item xstyle='margin:0' label='Site :'></el-form-item>
				<el-form-item>
				  <el-select size='small' style='width:200px' v-model="sitecode" Placeholder='Select Site' @change='filterReports'>
          <el-option v-for="item in codes.sites" 
      		           :key='item.code' 
			 	             :label="item.code + ' - ' + item.name" 
			  	  				 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
				<el-form-item>
				  <el-select size='small' style='width:250px' v-model="reportsel" Placeholder='Select Report'>
          <el-option v-for="item in selectviews" 
      		           :key='item.code' 
			 	             :label="item.code + ' - ' + item.name" 
			  	  				 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
				<el-form-item>
				  <el-select size='small' style='width:150px' v-model="periodsel" Placeholder='Select Period' @change='checkPeriode'>
          <el-option label="( Manual Period )" value='man'></el-option>
          <el-option v-for="item in codes.periods" 
      		           :key='item.code' 
			 	             :label="item.value" 
			  	  				 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
				<el-form-item>
				  <el-select size='small' style='width:100px' v-model="output" Placeholder='Select Output'>
          <el-option v-for="item in outtypes" 
      		           :key='item' 
			 	             :label="item" 
			  	  				 :value='item'></el-option>
  		    </el-select>
				</el-form-item>

        <el-form-item>
          <el-checkbox v-model='manType'>Select Type </el-checkbox>
          <el-button :disabled="reportsel==''" :type="buttonType" icon='el-icon-open' size='small' v-on:click="showReport();">Open</el-button>
				</el-form-item>
      </el-col>

      <el-col :span='24'>
        <span v-if="this.periodsel=='man'">                   
          <el-form-item label='Period:'>
            <el-select style='margin:0;width:120px' size='small' v-model='periodFrom'>
            <el-option v-for="item in codes.manPeriods" 
        		           :key='item.code' 
		  	 	             :label="item.value" 
			    	  				 :value='item.code'></el-option>
      	    </el-select>
          </el-form-item>
  
          <el-form-item label='Till:'>
            <el-select style='width:120px' size='small' v-model='periodTill'>
            <el-option v-for="item in codes.manPeriods" 
        		           :key='item.code' 
		  	 	             :label="item.value" 
			    	  				 :value='item.code'></el-option>
      	    </el-select>
          </el-form-item>
        </span>
   
        <span v-if="this.manType">
          <el-form-item label='Type :'>
            <el-select multiple size='mini' style='min-width:575px; x:500px' v-model="bookStatSel" Placeholder='Status'>
            <el-option v-for="item in codes.bookstatus" 
        		           :key='item.code' 
		  	 	             :label="item.value" 
			    	  				 :value='item.code'></el-option>
  		      </el-select>
         	</el-form-item>
        </span>
      </el-col>
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-col :span="24" style="padding-bottom: 0px;">
      <!--
      <el-input class="getHeight" v-loading="listLoading"  readonly type='textarea' rows='30'              
                style='font-family:system;font-size:12px;overflow:auto' v-model="reportdata"></el-input>
      -->
      <div id='area' style='padding:0 10px;line-height:1.5em;font-size:12px;border:1px solid #ccc;height:600px;overflow:auto'         v-loading='listLoading'><pre>{{reportdata}}</pre></div>
      
        
   	</el-col>
		<!-- Toolbar -->
		
		<el-col :span="24" style="margin-top:10px">
		  <el-button v-if="reportLoaded" type="warning" icon='el-icon-download' size='small' v-on:click="download();">Download {{lastType}} as File</el-button>
      <el-checkbox v-if="reportLoaded && this.lastType!='TABLE'" style='margin-left:20px' v-model='openApp'>Open App</el-checkbox>
   	</el-col>

	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/bas/report';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"Report"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,
        listLoading : false,

        outtypes    : ["TABLE","JSON","XML","CSV_NL","CSV_EN"],
        bookStatSel : ["ok","okx"],

        periodFrom  : "",
        periodTill  : "",
        output      : "TABLE",
        sitecode    : "",
        content     : "",
				editTitle   : "",
				editMode    : "",
				APICode     : "Report",
				mainFunc    : "Report",
				mainSubject : "Report",
        buttonType  : "primary",
        bookStatusView: false,
        openApp     : true,
        manType     : false,
             
        allviews: [],
        selectviews: [],

        report: [],
        reportsel: "",
        lastType: "",
        
        reportdata: "",
        reportLoaded: false,
        periodsel: "1",
        periodLast: "1"
			}
		},
		
		methods: {
 	  	closeForm: function () {
         this.selectorVisible = false;
    	},

      checkPeriode() {
        if (this.periodsel.startsWith("."))
          this.periodsel = this.periodLast;
        else this.periodLast = this.periodsel;
      },
      
      filterReports() {
        this.selectviews = [];      
        for(let i = 0;i < this.allviews.length;i++) {
          if (this.allviews[i].sitelist != undefined && (this.allviews[i].sitelist === "*" || this.allviews[i].sitelist.includes(this.sitecode)))
          {
            this.selectviews.push({code: this.allviews[i].code,name: this.allviews[i].name});
          }
        }
      },

      showReport() {
         this.listLoading = true;
			   this.getRecords();
      },
      // Ophalen record(s) via API
			getRecords() {
        this.periodLast = this.periodsel;
        this.listLoading = true;
  			this.buttonType = "primary-outline";
       
        let parg = {};
        parg.Params = {};
        parg.Params.site       = this.sitecode;
        parg.Params.report     = this.reportsel;     
        parg.Params.manType    = this.manType;
        parg.Params.typeList   = this.bookStatSel.join(",");

        if (this.output == "CSV_NL") {
          parg.Params.outtype = "CSV";
          parg.Params.csvsepp = ";";      
        }
        else if (this.output == "CSV_EN") {
          parg.Params.outtype = "CSV";
          parg.Params.csvsepp = ",";      
        }
        else parg.Params.outtype = this.output;

        if (this.periodsel == 'man')
          parg.Params.period = "man," + this.periodFrom + "," + this.periodTill;
        else parg.Params.period     = this.periodsel;
        
        window.sessionStorage.setItem("site",this.sitecode);
        window.sessionStorage.setItem("periodsel",parg.Params.period);
        window.sessionStorage.setItem("reportsel",this.reportsel);

        this.reportLoaded = false;

		    api.execute("",parg).then((res) => {					
          util.processMainResults(res);
        
          this.codes = util.codes;                  
          if (this.periodsel == "")
            this.periodsel = util.getMainHeader("lastperiod");          
          if (this.sitecode == "" && this.codes.sites[0]) this.sitecode = this.codes.sites[0].code;

          this.listLoading = false;
       		this.buttonType = "primary";
          
          if (res.data.payload.report) {
            this.reportdata = util.getMainPayload("report");     
            this.lastType = this.output;
            this.reportLoaded = true;
          }        

          this.allviews = util.getMainPayload("views");
          this.filterReports();

				})
        .catch((error) => {
          util.serverError(this);
          console.log("ERROR: " + this.message);
        });
			},

      download: function() {         
         const anchor = document.createElement('a');
         if (this.output == "TABLE")
         {
           anchor.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.reportdata);
           anchor.download = 'Content_' + this.periodsel + '.txt';
         }
         else if (this.output == "JSON")
         {
           anchor.href = 'data:' + (this.openApp ? "application/json":"text/plain") + 
                         ';charset=utf-8,' + encodeURIComponent(this.reportdata);
           anchor.download = 'Content_' + this.periodsel + '.json';
         }
         else if (this.output == "XML")
         {
           anchor.href = 'data:' + (this.openApp ? "application/xml":"text/plain") + 
                         ';charset=utf-8,' + encodeURIComponent(this.reportdata);
           anchor.download = 'Content_' + this.periodsel + '.xml';
         }
         else if (this.output == "CSV" || this.output == "CSV_NL" || this.output == "CSV_EN" )
         {
           anchor.href = 'data:' + (this.openApp ? "text/csv":"text/plain") + 
                         ';charset=utf-8,' + encodeURIComponent(this.reportdata);
           anchor.download = 'Content_' + this.periodsel + '.csv';
         }

         anchor.target = '_blank';
         anchor.click(); 
      },
       
		},

		mounted() {
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });
      
      if (this.$route.params) {
        this.stack = this.$route.params;
      }
      
      
      if (window.sessionStorage.getItem("site"))
        this.sitecode = window.sessionStorage.getItem("site");
      if (window.sessionStorage.getItem("periodsel")) {
         var arr = window.sessionStorage.getItem("periodsel").split(",");
         this.periodsel = arr[0];//window.sessionStorage.getItem("periodsel");
         if (arr.length > 0) this.periodFrom = arr[1];
         if (arr.length > 1) this.periodTill = arr[2];

      }

      //if (window.sessionStorage.getItem("reportsel"))
      //  this.reportsel = window.sessionStorage.getItem("reportsel");
     	
      this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// report.vue?e1351b06